import { render, staticRenderFns } from "./UserComments.vue?vue&type=template&id=091dc7aa&"
import script from "./UserComments.vue?vue&type=script&lang=js&"
export * from "./UserComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports